module.exports = __webpack_public_path__ + "img/goblin.c100b37b.svg";